import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import {injectIntl} from 'react-intl';
import * as yup from 'yup';
import _ from 'lodash';

import InputWidget from './InputWidget';

class MultipleChoiceWidget extends InputWidget {

    /**
     * Prüft ob der übergebene Wert durch das onChange-event in den formik state existiert und dementsprechend#
     * ob die checkbox checked oder unchecked ist
     *
     * @param value
     * @return boolean
     */
    isChecked(value) {
        if (this.props.formikProps.values.widgets[this.props.widget.id] === undefined) {
            return false;
        }

        return this.props.formikProps.values.widgets[this.props.widget.id].includes(value);
    }

    getLocalisedChoices() {
        return _.get(this.props, ['widget', 'choices', this.props.intl.locale], []);
    }

    handleChange = event => {
        const target = event.currentTarget;
        let selectedValues = [...this.getValue()] || [];

        if (target.checked) {
            if (!selectedValues.includes(target.value)) {
                selectedValues.push(target.value);
            }
        } else {
            selectedValues.splice(selectedValues.indexOf(target.value), 1);
        }
        // Werte sortieren, damit die Daten verschiedener Einreichungen optisch einfacher zu vergleichen sind.
        selectedValues.sort();
        this.props.formikProps.setFieldValue(this.getFieldName(), selectedValues);
    };

    render() {
        return (
            <Form.Group>
                <Form.Label>{this.renderLabelText()}</Form.Label>
                {this.getLocalisedChoices().map((choice, index) => (
                    // Es muss der index als key genommen werden, da nicht garantiert ist,
                    // dass label oder value der choice eindeutig sind.
                    <Form.Check type="checkbox"
                                id={`${this.getFieldName()}-${index}`}
                                name={`${this.getFieldName()}-${index}`}
                                key={index}
                                value={choice.value}
                                label={choice.label}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                checked={this.isChecked(choice.value)}
                                disabled={this.props.disabled}
                                data-testid={this.props.widget.id}
                    />
                ))}
                {/*
                    <Form.Control.Feedback> funktioniert nur bzgl. einer umgebenden <Form.Control> Komponente,
                    da wir aber die Fehlermeldung für die gesamte Gruppe an Checkboxen anzeigen wollen, müssen
                    wir diese Fehlermeldung selbst anzeigen.
                 */}
                {this.isInvalid() ? <small className="form-text text-danger">{this.getError()}</small> : null}
                {this.getCustomRequiredError()}
            </Form.Group>
        );
    }
}

MultipleChoiceWidget.propTypes = {
    widget: PropTypes.object,
    intl: PropTypes.object
};

const IntlMultipleChoiceWidget = injectIntl(MultipleChoiceWidget);

export function type() {
    return 'choice_multiple';
}

export function initialValue(widget) {
    return [];
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {NotRequiredNullableArraySchema<string | undefined, object>}
 */
export function schema(widget, allowPartialSubmissions) {
    let schema = yup.array()
        .of(yup.string())
        .strict(true)
        .nullable();

    if (!allowPartialSubmissions && widget.required) {
        schema = schema.required();
    }

    return schema;
}

export function component() {
    return IntlMultipleChoiceWidget;
}
